import React from 'react'
import PropTypes from 'prop-types'

import HSMonthlyBill from '../HSMonthlyBill'
import MobilityMonthlyBill from '../MobilityMonthlyBill'

const MHMonthlyBill = ({ cart, dataTestId, hsTotalPrice, isAuthenticated, mobTotalPrice }) => (
  <div data-testid={`${dataTestId}-price-summary-m&h-monthlybill`}>
    {hsTotalPrice && (
      <HSMonthlyBill
        totalPrice={hsTotalPrice}
        cart={cart}
        isAuthenticated={isAuthenticated}
        dataTestId={dataTestId}
        isHsOnly={false}
      />
    )}
    {mobTotalPrice && (
      <MobilityMonthlyBill
        totalPrice={mobTotalPrice}
        isAuthenticated={isAuthenticated}
        dataTestId={dataTestId}
        cart={cart}
      />
    )}
  </div>
)

MHMonthlyBill.propTypes = {
  cart: PropTypes.object.isRequired,
  dataTestId: PropTypes.string.isRequired,
  hsTotalPrice: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  mobTotalPrice: PropTypes.object
}

MHMonthlyBill.defaultProps = {
  hsTotalPrice: undefined,
  mobTotalPrice: undefined
}

export default MHMonthlyBill
